export default {
  // Estado de la rutina
  status: {
    created: 'En edición',
    scheduled: 'Programada',
    extended: 'Programanda',
    rescheduled: 'Programanda',
    active: 'Activa',
    finished: 'Finalizada'
  },

  // Periodicidad (forma corta y forma larga/adverbial)
  periodicity: {
    daily: 'diario',
    weekly: 'semanal',
    monthly: 'mensual',
    daily_long: 'diariamente',
    weekly_long: 'semanalmente',
    monthly_long: 'mensualmente'
  },
  preview: {
    usersAdded: 'Se agregarán {count} usuario(s) nuevo(s).',
    usersRemoved: 'Se quitarán {count} usuario(s).',
    activitiesToGenerate: 'Se generarán aproximadamente {count} actividad(es) nueva(s).',
    activitiesToDelete: 'Se eliminarán {count} actividad(es) programada(s).',
    usersExcluded: '{users} usuario(s) no se agregarán a {activities} actividad(es) por días y horas: ' +
      'tienen varias ubicaciones (o ninguna) en el rol. Asígnales la ubicación en cada actividad.'
  }
}
